import { t } from 'ember-intl';
import { and, eq, not } from 'ember-truth-helpers';
import BvAvatar from 'volta/components/bv-avatar';
import BvInline from 'volta/components/bv-inline';
import BvStack from 'volta/components/bv-stack';
import BvText from 'volta/components/bv-text';
import me from 'volta/helpers/me';

import type { TOC } from '@ember/component/template-only';
import type User from 'volta/models/user';

interface UserListItemSignature {
  Args: {
    isSelected?: boolean;
    hideEmail?: boolean;
    option: User;
  };
  Element: HTMLElement;
}

const UserListItemComponent: TOC<UserListItemSignature> = <template>
  {{#let (me) as |me|}}
    <BvInline @blockAlign='center' @gap='2' @wrap={{false}} ...attributes>
      <BvAvatar
        @size='xs'
        @firstName={{@option.firstName}}
        @lastName={{@option.lastName}}
        @login={{@option.login}}
        @background={{if
          @option.isInactive
          'gray-2'
          (if (eq me.userId @option.userId) 'primary' 'indigo')
        }}
        @presence={{if @option.isInactive 'inactive' (if @option.connected 'online' 'offline')}}
      />
      <BvStack>
        <BvText
          @text={{if (eq me.userId @option.userId) (t 'me') @option.displayName}}
          @truncate={{true}}
        />
        {{#if (and (not @isSelected) @option.email (not @hideEmail))}}
          <BvText @color='subdued' @text={{@option.email}} @variant='body-sm' @truncate={{true}} />
        {{/if}}
      </BvStack>
    </BvInline>
  {{/let}}
</template>;

export default UserListItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'User::ListItem': typeof UserListItemComponent;
    'user/list-item': typeof UserListItemComponent;
  }
}
